import { GET_ALBUM_SUCCESS, GET_MORE_TRACKS_ALBUM_SUCCESS } from '../../pages/album/albumActions'
import { GET_TRACK_SUCCESS } from '../../pages/track/trackActions'
import { GET_ARTIST_SUCCESS } from '../../pages/artist/artistActions'
import { GET_PLAYLIST_SUCCESS } from '../../pages/playlist/playlistActions'

const trackListInit = {
	offset: 0,
	limit: 20,
	total: 0,
	media_count: 0,
	items: []
}
export default (state = trackListInit, action) => {
	switch (action.type) {
		case GET_ALBUM_SUCCESS:
			if (action.album && action.album.tracks) {
				return {
					...action.album.tracks,
					media_count: action.album.media_count,
					items: action.album.tracks.items ? action.album.tracks.items.map(track => ({
						id: track.id,
						title: track.title,
						version: track.version,
						performer: track.performer,
						work: track.work,
						composer: track.composer,
						duration: track.duration,
						track_number: track.track_number,
						sampleable: track.sampleable,
						media_number: track.media_number,
						albumId: track.album ? track.album.id : undefined,
						parental_warning: track.parental_warning
					})) : undefined
				}
			}
			return trackListInit
		case GET_MORE_TRACKS_ALBUM_SUCCESS:
			if (action.album && action.album.tracks) {
				return {
					...state,
					...action.album.tracks,
					items: [
						...state.items,
						...(action.album.tracks.items ? action.album.tracks.items.map(track => ({
							id: track.id,
							title: track.title,
							version: track.version,
							performer: track.performer,
							work: track.work,
							composer: track.composer,
							duration: track.duration,
							track_number: track.track_number,
							sampleable: track.sampleable,
							media_number: track.media_number,
							albumId: track.album ? track.album.id : undefined,
							parental_warning: track.parental_warning
						})) : [])
					]
				}
			}
			break
		case GET_TRACK_SUCCESS:
			if (action.track) {
				return {
					offset: 0,
					limit: 1,
					total: 1,
					items: [{
						id: action.track.id,
						title: action.track.title,
						version: action.track.version,
						work: action.track.work,
						composer: action.track.composer,
						performer: action.performer,
						duration: action.track.duration,
						track_number: action.track.track_number,
						sampleable: action.track.sampleable,
						media_number: 1,
						albumId: action.track.album ? action.track.album.id : undefined,
						parental_warning: action.track.parental_warning
					}]
				}
			}
			return trackListInit
		case GET_ARTIST_SUCCESS:
			if (action.topTracks) {
				return {
					...action.topTracks,
					items: action.topTracks.items ? action.topTracks.items.slice(0, 5).map(track => ({
						id: track.id,
						title: track.title,
						version: track.version,
						work: track.work,
						composer: track.composer,
						performer: track.performer,
						duration: track.duration,
						track_number: track.track_number,
						album: track.album ? track.album.title : '',
						albumId: track.album ? track.album.id : undefined,
						sampleable: track.sampleable,
						cover: track.album && track.album.image ? track.album.image.thumbnail : undefined,
						media_number: 1,
						parental_warning: track.parental_warning
					})) : undefined
				}
			}
			return trackListInit
		case GET_PLAYLIST_SUCCESS:
			if (action.playlist && action.playlist.tracks) {
				return {
					...action.playlist.tracks,
					items: action.playlist.tracks.items && action.playlist.tracks.items.length ? action.playlist.tracks.items.map(
						track => ({
							id: track.id,
							title: track.title,
							version: track.version,
							work: track.work,
							composer: track.composer,
							duration: track.duration,
							track_number: track.track_number,
							album: track.album ? track.album.title : '',
							albumId: track.album ? track.album.id : undefined,
							performer: track.performer,
							artist: track.album && track.album.artist ? track.album.artist.name : '',
							artistId: track.album && track.album.artist ? track.album.artist.id : undefined,
							sampleable: track.sampleable,
							cover: track.album && track.album.image ? track.album.image.thumbnail : undefined,
							media_number: 1,
							parental_warning: track.parental_warning
						})
					) : []
				}
			}
			return trackListInit
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/components/tracklist/trackListReducer.js